'use strict';
var $ = require('../internals/export');
var global = require('../internals/global');

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$({ global: true, forced: global.globalThis !== global }, {
  globalThis: global
});



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/modules/es.global-this.js
// module id = 2024
// module chunks = 0